export default __webpack_public_path__ + "static/media/language.b628671e.svg";